import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator, uuidValidator } from '../../validators';

export const CreateWordComparisonSchema = z.object({
  languages: z
    .array(languageEnumValidator)
    .optional()
    .default([LanguageEnum.RU]),
  wordIds: z
    .array(uuidValidator)
    .min(2, 'At least two words are required for comparison')
    .refine((ids) => new Set(ids).size === ids.length, {
      message: 'Word IDs must be unique',
    }),
  customNotes: z.string().min(1).optional(),
});

export type ICreateWordComparisonDto = z.infer<
  typeof CreateWordComparisonSchema
>;
